import type { FaireProductEntity } from "../../entity_types/product";

export const p_k9rw7yh9yr: FaireProductEntity = {
  token: "p_k9rw7yh9yr",
  type: "product",
  name: "Heart Mom Charm with Opal, CZ Monogram for Necklace,CPG838",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/ed08c774da07579b4396ce62c2dc6d5581c9e1ffcf58d6b89e9687c20dc1139a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ded51ef2e837b3577ffe099040e33da68738b17fe368a100329d54fd6ae29cb6.jpeg",
    "https://cdn.faire.com/fastly/9ad00b2510a03f3bf8e66f8c96ee10e7356eead3414439b8d574c4a050607e9d.jpeg",
    "https://cdn.faire.com/fastly/331e7b100c922ea4e75dadbb089b202c75c611c9d2615ec517321bcdcf3557a6.jpeg",
    "https://cdn.faire.com/fastly/0a370c656e758d22db5b89798b19c7beb7cc08446581f0df3a744fe4500a1a14.jpeg",
    "https://cdn.faire.com/fastly/4bd7e8fe0e805e21a7be90d7b15fac2f07cb151daedf77cc30ba40e0e82dacac.jpeg",
    "https://cdn.faire.com/fastly/b9f32df1806a080265ecc14d9ed0a2ad5b7f07982d80d5e7a030c182a9bc40d2.jpeg",
    "https://cdn.faire.com/fastly/d781506b3de7a837b4dc54f788238ae6c4847e27cd267519cb619120af45311b.jpeg",
    "https://cdn.faire.com/fastly/9d3d7ddf26d922d7c4dc084d1bf13024ed8ec721eb40cbc55cf9b821b50c0cd9.jpeg",
    "https://cdn.faire.com/fastly/05026dd4004859ebd909b686b3ba863245221518e8d66646afd11ac9a626d7b0.jpeg",
  ],
  priceDollars: 3.44,
  description:
    "Monogram Mom Heart Charm Pave Set With CZ And Opal Inlay,High Polished Shiny Finished,CPG838\nThis Listing Is For One Single Piece.\n\nPlease select the color from the menu.\n\n14K Gold,Rhodium,Rose Gold And Gun Metal Plating Over Brass\nStones:Opal And Cubic Zirconia\nMeasurements:\n16.2mm x 11.1mm\nThickness:1.5mm\nOpen Jump Ring:4mm\nAll Sizes Are Approximate\nLead, Cadmium and nickel free\nQuantity discount available at drop down menu**\nShip From Los Angeles",
  tags: [],
  msrpDollars: 6.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:57.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
